import type { SxProps, Theme } from "@mui/material";
import { type FC, type ReactNode } from "react";

import * as Styled from "./EventSectionTitle.styles";

interface IEventSectionTitleProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export const EventSectionTitle: FC<IEventSectionTitleProps> = ({ children, sx }) => {
  return (
    <Styled.Root
      component="h2"
      variant="subtitle1"
      sx={[{ fontWeight: 600 }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {children}
    </Styled.Root>
  );
};
